import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect, useParams } from 'react-router-dom';
import { fetchPartnerConfig } from '../reducers/Auth/actions';

const DynamicPartnerRedirect = () => {
  const { partnerName } = useParams();
  const dispatch = useDispatch();
  const { partnerConfig, isPartnerConfigLoading } = useSelector(
    ({ AuthReducer }) => AuthReducer,
  );

  useEffect(() => {
    if (partnerName) {
      dispatch(fetchPartnerConfig(partnerName));
    }
  }, [partnerName, dispatch]);

  // Show loading or wait for config to be fetched
  if (isPartnerConfigLoading) {
    return <div>Loading...</div>; // You might want to use a proper loading component
  }

  // If no partner config found, redirect to home
  if (!partnerConfig) {
    return <Redirect to="/" />;
  }

  return <Redirect to={`/?partner=${partnerName}`} />;
};

export default DynamicPartnerRedirect;
